import { atom } from 'jotai';

export const payPalTokenAtom = atom<string | null>(null);
